import { Graphics } from 'pixi.js';

// Slow-field overlay — yellow edge vignette telegraphing the time-slow special.
// Pure stateless render — caller owns the Graphics + the timer.
export function drawSlowFieldEdges(g: Graphics, timer: number, W: number, H: number): void {
  if (timer <= 0) {
    if (g.visible) {
      g.visible = false;
      g.clear();
    }
    return;
  }
  g.visible = true;
  g.clear();
  const a = Math.min(1, timer / 0.4) * 0.18;
  const t = 80;
  g.rect(0, 0, W, t);                  g.fill({ color: 0xffff66, alpha: a * 0.5 });
  g.rect(0, H - t, W, t);              g.fill({ color: 0xffff66, alpha: a * 0.5 });
  g.rect(0, t, t, H - t * 2);          g.fill({ color: 0xffff66, alpha: a * 0.5 });
  g.rect(W - t, t, t, H - t * 2);      g.fill({ color: 0xffff66, alpha: a * 0.5 });
}
